<template>
  <v-row>
    <div>
      <QuotationBackButton
        v-if="form.cancelada_em == null"
        @back="previousPage"
        class="ml-4"
      />
    </div>
    <v-spacer />
    <div>
      <ResumeProcessQuotationAgro
        :form="form"
        v-if="form != null"
        @return="previousPage"
      />
    </div>
  </v-row>
</template>

<script>
import ResumeProcessQuotationAgro from "../components_agro/ResumeProcessQuotationAgro.vue";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import QuotationBackButton from "../components_agro/QuotationBackButton";
export default {
  data: () => ({
    show: false
  }),
  components: {
    ResumeProcessQuotationAgro,
    QuotationBackButton
  },
  mixins: [LoadingRequest],
  methods: {
    previousPage() {
      this.$emit("return");
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
